<template>
    <div id="footer-nav" v-if="kiosk.id">
        <router-link to="/" class="home">
            <span class="icon"></span>
            <span>Home</span>
        </router-link>
        <router-link to="/area-map/" class="area-map" v-if="hasAreamap">
            <span class="icon"></span> Area Map
        </router-link>
        <router-link to="/galleries/" class="galleries" v-if="hasGalleries">
            <span class="icon"></span> Photos &amp; Videos
        </router-link>
        <router-link to="/floorplans/" class="floorplans" v-if="hasFloorplans">
            <span class="icon"></span> Floorplans
        </router-link>
        <router-link to="/move-in-ready/" class="inventory" v-if="hasInventory">
            <span class="icon"></span> Move In Ready
        </router-link>
        <router-link to="/lifestyles/" class="lifestyles" v-if="hasLifestyles">
            <span class="icon"></span> Lifestyles
        </router-link>
        <router-link to="/about-kolter/" class="kolter" v-if="hasKolter">
            <span class="icon"></span> About Kolter
        </router-link>
        <router-link to="/site-plan/" class="site-plan" v-if="hasSiteplan">
            <span class="icon"></span> Site Plan
        </router-link>
        <router-link to="/my-favorites/" class="my-favorites" :class="{ 'has-favorites' : favorites > 0 }" v-if="canShowFavoritesAndLogin">
            <i class="favorites">{{ favorites }}</i>
            <span class="icon"></span> My Favorites
        </router-link>
        <a href="#" :class="{'sign-in': !isLoggedIn, 'sign-out': isLoggedIn, 'disabled': isOffline }" @click.stop="toggleModal()" v-if="canShowFavoritesAndLogin">
            <span class="icon"></span>
            <span v-html="loginButtonText"></span>
        </a>
    </div>
</template>

<script>
    export default {
        props : ["kiosk"],
        computed:{
            canShowFavoritesAndLogin() {
                return this.hasAreamap || this.hasFloorplans || this.hasInventory ? true : false;
            },
            customer() { return this.$store.state.customer; },
            favorites() { return this.$store.state.favorites.length; },
            hasAreamap() { return this.$store.getters.hasAreamap; },
            hasGalleries() { return this.$store.getters.hasGalleries; },
            hasFloorplans() { return this.$store.getters.hasFloorplans; },
            hasInventory() { return this.$store.getters.hasInventory; },
            hasLifestyles() { return this.$store.getters.hasLifestyles; },
            hasKolter() { return this.$store.getters.hasKolter; },
            hasSiteplan() { return this.$store.getters.hasSiteplan; },
            isBrochure(){ return this.$route.name === "Brochure"; },
            isLoggedIn() { return this.customer.id ? true : false; },
            isOffline(){ return this.$store.state.isOffline; },
            loginButtonText() {
                return this.isLoggedIn ?
                    `Leave Session <small>${this.customer.firstName}</small>` :
                    "Login / Register";
            },
            menuOpen() { return this.$store.state.menuOpen || false; }
        },
        methods: {
            toggleModal() {
                if ( this.isOffline )
                    this.$store.dispatch( "openModal", { action:"offline" } );
                else if ( this.isLoggedIn )
                    this.$store.dispatch( "openModal", { action:"log-out" } );
                else
                    this.$store.dispatch( "openModal", { action:"account-state", isModal: true } );
            }
        }
    };
</script>
